"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { getMonthWeeks, getWeekdayNames, getLocalISODate, isDateFocusable } from "./Calendar.utils.js";
import CalendarDate from "./CalendarDate.js";
import s from "./Calendar.module.css";
const CalendarMonth = (props) => {
    const { date, value, onChange, min, max, range, firstWeekDay, selectedDates, hoveredDate, onDateHover, onDateHoverEnd, renderWeekDay, renderDateAriaLabel, } = props;
    let foundFocusableDate = false;
    const [lastFocusedDate, setLastFocusedDate] = useState();
    const month = date.getMonth();
    const weeks = getMonthWeeks({ date, firstWeekDay });
    const weekdayNames = getWeekdayNames({ firstWeekDay, renderWeekDay });
    return (_jsxs("table", { className: s.selection, role: "grid", children: [_jsx("thead", { "aria-hidden": "true", children: _jsx("tr", { children: weekdayNames.map((dayName) => (_jsx("th", { className: s.weekday, scope: "col", children: dayName }, dayName))) }) }), _jsx("tbody", { children: weeks.map((week) => {
                    const key = [month, week[0]?.getDate()].filter(Boolean).join("-");
                    return (_jsx("tr", { className: s.row, children: week.map((date, index) => {
                            const disabled = !!date && ((min && date < min) || (max && date > max));
                            const startValue = value && "start" in value ? value.start : value;
                            const endValue = value && "end" in value ? value.end : value;
                            const isoDate = date && getLocalISODate({ date });
                            const focusable = disabled
                                ? false
                                : !foundFocusableDate &&
                                    !!date &&
                                    isDateFocusable({ date, lastFocusedDate, startValue });
                            // eslint-disable-next-line react-hooks/immutability
                            if (focusable)
                                foundFocusableDate = true;
                            return (_jsx(CalendarDate, { date: date, isoDate: isoDate, disabled: disabled, range: range, focusable: focusable, startValue: startValue, endValue: endValue, onChange: onChange, hoveredDate: hoveredDate, onDateHover: onDateHover, onDateHoverEnd: onDateHoverEnd, onDateFocus: setLastFocusedDate, renderAriaLabel: renderDateAriaLabel, selectedDates: selectedDates }, index));
                        }) }, key));
                }) })] }));
};
CalendarMonth.displayName = "CalendarMonth";
export default CalendarMonth;
